import React from "react";
import { localizeDateFormat } from "utilities/DateFormatter";

const StatusIcon = ({
  isCompleted,
  remainingCount = null,
}: {
  isCompleted: boolean;
  remainingCount?: number | null;
}) => {
  if (isCompleted) {
    return <span className="flex justify-center">○</span>;
  } else if (remainingCount !== null && remainingCount > 0) {
    return (
      <span className="flex justify-center text-red-500">
        残{remainingCount}枚
      </span>
    );
  } else {
    return <span className="flex justify-center"></span>;
  }
};

const DeliveryStatus = ({ isDelivered }: { isDelivered: boolean }) => {
  if (isDelivered) {
    return <span className="flex justify-center">○</span>;
  } else {
    return <span className="flex justify-center text-red-500">!</span>;
  }
};

type UploadPictureStatusProps = {
  isUploaded: boolean;
  isAICompleted: boolean;
  remainingAIPictures: number;
  isAllChecked: boolean;
  numberUncheckedPics?: number;
  isDelivered?: boolean;
  lastDeliveryDate?: string | null;
};

const UploadPictureStatus: React.FC<UploadPictureStatusProps> = ({
  isUploaded,
  isAICompleted,
  remainingAIPictures,
  isAllChecked,
  isDelivered = false,
  lastDeliveryDate = null,
  numberUncheckedPics = 0,
}: {
  isUploaded: boolean;
  isAICompleted: boolean;
  remainingAIPictures: number;
  isAllChecked: boolean;
  numberUncheckedPics?: number;
  isDelivered?: boolean;
  lastDeliveryDate?: string | null;
}) => {
  return (
    <>
      <td className="p-2 text-center border border-gray-300">
        <StatusIcon isCompleted={isUploaded} />
      </td>

      <td className="p-2 text-center border border-gray-300">
        {isUploaded ? (
          isAICompleted ? (
            <StatusIcon isCompleted={true} />
          ) : remainingAIPictures > 0 ? (
            <p className="text-red-500">残{remainingAIPictures}枚</p>
          ) : (
            <StatusIcon isCompleted={false} />
          )
        ) : (
          <StatusIcon isCompleted={false} />
        )}
      </td>

      <td className="p-2 text-center border border-gray-300">
        {isAllChecked ? (
          <StatusIcon isCompleted={true} />
        ) : numberUncheckedPics > 0 ? (
          <StatusIcon
            isCompleted={false}
            remainingCount={numberUncheckedPics}
          />
        ) : (
          <StatusIcon isCompleted={false} />
        )}
      </td>

      <td className="p-2 text-center border border-gray-300">
        {isUploaded ? (
          isDelivered ? (
            <span className="flex justify-center"></span>
          ) : (
            <DeliveryStatus isDelivered={isDelivered} />
          )
        ) : (
          <span className="flex justify-center"></span>
        )}
      </td>

      <td className="p-2 text-center border border-gray-300">
        {lastDeliveryDate ? (
          <span className="flex justify-center">
            {localizeDateFormat(lastDeliveryDate)}
          </span>
        ) : (
          <span className="flex justify-center"></span>
        )}
      </td>
    </>
  );
};

export default UploadPictureStatus;
